/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { PlatformStoresService } from './services/platform-stores.service';
import { PlatformIntegrationsService } from './services/platform-integrations.service';
import { PlatformUsersService } from './services/platform-users.service';
import { PlatformUsersSuperAdminsService } from './services/platform-users-super-admins.service';
import { PlatformShopifyAppService } from './services/platform-shopify-app.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    PlatformStoresService,
    PlatformIntegrationsService,
    PlatformUsersService,
    PlatformUsersSuperAdminsService,
    PlatformShopifyAppService,
    ApiConfiguration,
  ],
})
export class PlatformApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<PlatformApiModule> {
    return {
      ngModule: PlatformApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: PlatformApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('PlatformApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
